import GiveConsent from './GiveConsent';

export default GiveConsent;
